import { h, Component } from 'preact';

const FALLBACK = <div class="loading">Loading....</div>;

export default (load, importName) => props => (
	<SplitPoint load={load} importName={importName} {...props} />
);

export class SplitPoint extends Component {
	componentWillMount() {
		let setChild = child => {
			if (this.props.importName) {
				child = child[this.props.importName] || child;
			}
			if (child && typeof child==='object' && child.default) {
				child = child.default;
			}
			if (child!==this.state.child) {
				this.setState({ child });
			}
		};

		let ret = this.props.load(setChild);
		if (ret && ret.then) ret.then(setChild);
	}

	render({ load, fallbackContent, ...props }, { child }) {
		return child ? h(child, props) : fallbackContent || FALLBACK;
	}
}



// WEBPACK FOOTER //
// ../node_modules/@os/split-point/src/index.js